/// <reference types="./OpaqueCursor.d.ts" />
import { notOk, ok } from '@dossierhq/core';
import { assertExhaustive } from '../utils/AssertUtils.js';
export function toOpaqueCursor(database, type, value) {
    switch (type) {
        case 'int':
            return database.adapter.encodeCursor(String(value));
        case 'string':
            return database.adapter.encodeCursor(value);
        default:
            assertExhaustive(type);
    }
}
export function fromOpaqueCursor(database, type, cursor) {
    switch (type) {
        case 'int': {
            const decoded = database.adapter.decodeCursor(cursor);
            const value = Number.parseInt(decoded);
            if (Number.isNaN(value)) {
                return notOk.BadRequest('Invalid format of cursor');
            }
            return ok(value);
        }
        case 'string': {
            const value = database.adapter.decodeCursor(cursor);
            return ok(value);
        }
        default:
            assertExhaustive(type);
    }
}
//# sourceMappingURL=OpaqueCursor.js.map